module.exports = __webpack_public_path__ + "static/media/shirtSquare.10a2dd9a.png";